var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-autocomplete',{staticClass:"gmap-autocomplete",attrs:{"select-first-on-enter":true,"placeholder":_vm.t('globalMapSearchPlaceholder'),"options":{
    fields: ['geometry'],
    sessionToken: _vm.sessionToken,
  }},on:{"place_changed":_vm.updateCurrentPlace}})
}
var staticRenderFns = []

export { render, staticRenderFns }